export default __webpack_public_path__ + "airplane.4afbb32dde4c117ffeeaa196ccb2a283.png";